export class ModelBase {
    id: string;
}